module.exports = __webpack_public_path__ + "static/media/uberEats-4.7ac9dcbf.png";